export default __webpack_public_path__ + "static/media/img12.84a50040.png";